export default {"src":"/_next/static/media/0xaf88d065e77c8cc2239327c5edb3a432268e5831.6f7cbaef.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};